var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.5C5 3.22386 5.22386 3 5.5 3H10.05C10.0172 3.16155 10 3.32877 10 3.5V12.5C10 12.7761 9.77614 13 9.5 13C9.22386 13 9 12.7761 9 12.5V11C9 10.4477 8.55228 10 8 10H5V3.5ZM12 3.5C12 3.22386 12.2239 3 12.5 3C12.7761 3 13 3.22386 13 3.5C13 3.77614 12.7761 4 12.5 4C12.2239 4 12 3.77614 12 3.5ZM12.5 6C12.3288 6 12.1616 5.98279 12 5.94999V12.5C12 13.8807 10.8807 15 9.5 15H3.5C2.11929 15 1 13.8807 1 12.5V11C1 10.4477 1.44772 10 2 10H3V3.5C3 2.11929 4.11929 1 5.5 1H12.5C13.8807 1 15 2.11929 15 3.5C15 4.88071 13.8807 6 12.5 6ZM7 12.5C7 12.6712 7.01722 12.8384 7.05001 13H3.5C3.22386 13 3 12.7761 3 12.5V12H7V12.5ZM9 4H6V5H9V4ZM8 6H6V7H8V6ZM6 8H9V9H6V8Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/Scroll.95b00aa7f44ce25a092b77f625a1cc15.svg";
export { ForwardRef as ReactComponent };